<!--
  ~ Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
  ~ This software is released under MIT license.
  ~ The full license information can be found in LICENSE in the root directory of this project.
  -->

<clr-alerts-pager *ngIf="multiAlertService.count > 1" [clrCurrentAlertIndex]="currentAlertIndex"></clr-alerts-pager>
<ng-content select="clr-alert"></ng-content>
